import { IPopupConfigService } from './../../services/popup_config_service/popup_config_service_type';

class PopupContainerController {
  constructor(private ngPopupService: IPopupConfigService) {}
}

export class PopupContainerComponent implements angular.IComponentOptions {
  public templateUrl: string = 'ui-ng-popup/src/components/popup_container/popup_container.html';
  public controller: any = PopupContainerController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-popup/src/components/popup_container/popup_container.ts